import { motion, type HTMLMotionProps, type Variants } from 'framer-motion';
import { type ReactNode } from 'react';

interface FadeInProps extends HTMLMotionProps<'div'> {
    children: ReactNode;
    delay?: number;
    duration?: number;
    y?: number;
    className?: string;
}

export function FadeIn({ children, delay = 0, duration = 0.5, y = 24, className, ...props }: FadeInProps) {
    return (
        <motion.div
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration, delay, ease: [0.16, 1, 0.3, 1] }}
            className={className}
            {...props}
        >
            {children}
        </motion.div>
    );
}

interface StaggerChildrenProps {
    children: ReactNode;
    className?: string;
    staggerDelay?: number;
}

export function StaggerChildren({ children, className, staggerDelay = 0.1 }: StaggerChildrenProps) {
    return (
        <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-60px' }}
            variants={{
                visible: {
                    transition: { staggerChildren: staggerDelay },
                },
            }}
            className={className}
        >
            {children}
        </motion.div>
    );
}

export const staggerItem: Variants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.5, ease: [0.16, 1, 0.3, 1] as [number, number, number, number] },
    },
};

export { motion };
